import { UserCustomers } from './user';

export class Role {
  id?: number;
  name?: string;
  privilege?: string;
  createdDate?: string;
  createdBy?: string;
  updatedDate?: string;
  updatedBy?: string;
  entityId?: string;
}

export class UserActions {
  id: string;
  userAction: string;
}

export class NavItem {
  displayName: string;
  disabled?: boolean;
  id?: string;
  iconName?: string;
  route?: string;
  children?: NavItem[];
  userActions?: UserActions[];
}

export interface Module {
  moduleName?: string;
  moduleId?: number;
  src?: string;
  outIcon?: string;
  overIcon?: string;
  routeUrl?: string;
  navItems?: NavItem[];
}

export class UserModulesByCustomer {
  cusId: string;
  modules: Module[];
}

export class Entity {
  entId?: number;
  entName?: string;
}

export class Error {
  code?: string;
  description?: string;
}

export class FscAuthorizedMenusResponse {
  requestIdentifier?: string;
  approvalStatus?: string;
  transactionDate?: string;
  success?: boolean;
  errors?: Error[] = [];
  roles?: Role[] = [];
  userCustomers?: UserCustomers[] = [];
  userModulesByCustomer?: UserModulesByCustomer[] = [];
}

export class FscAuthorizedMenusResolver {
  fscAuthorizedMenusResponse?: FscAuthorizedMenusResponse;
  error?: any;
}


